module.exports = __webpack_public_path__ + "static/media/Sec-4_2677_ID.45a4988a.png";